<template>
  <div class="renewPrice">
    <div class="renewPrice__header">
      <span class="label"> 订单号：</span>
      <el-input v-model="params.orderId" size="small" class="w__160" placeholder="请输入订单号" />
      <span class="label">SIM卡号：</span>
      <el-input v-model="params.simCard" size="small" class="w__160" placeholder="请输入SIM卡号" />
      <span class="label">订单状态：</span>
      <el-select
        v-model="params.status"
        placeholder="请选择"
        size="small"
        class="w__120"
      >
        <el-option
          v-for="item in statusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span class="label">处理状态：</span>
      <el-select
        v-model="params.handleState"
        placeholder="请选择"
        size="small"
        class="w__120"
      >
        <el-option
          v-for="item in handleStateList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <span class="label">操作时间：</span>
      <el-date-picker
        v-model="params.time"
        size="small"
        type="daterange"
        range-separator="至"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      <el-button
        style="margin-left:10px"
        type="primary"
        size="small"
        @click="getData(true)"
      >查询</el-button>
      <el-button :disabled="orderIds.length === 0" @click="onEditStatue(orderIds)" type="primary" size="small">批量处理</el-button>
      <el-button
        style="margin-left:10px"
        type="primary"
        size="small"
        @click="onExport"
      >导出</el-button>
    </div>
    <div class="renewPrice__content" v-loading="loading">
      <div class="filter-table-wrap">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          size="mini"
          ref="refTable"
          border
          @selection-change="onSelect"
          height="calc(100% - 90px)">
          <el-table-column
            type="selection"
            width="55">
          </el-table-column>
          <el-table-column
            type="index"
            width="50"
            label="序号"
          >
          </el-table-column>
          <el-table-column
            prop="orderId"
            align="center"
            label="订单号"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="sn"
            align="center"
            label="SN号"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="iccid"
            align="center"
            label="ICCID"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="simCard"
            align="center"
            label="SIM卡号"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="createTime"
            align="center"
            label="续费日期"
          >
          </el-table-column>
          <el-table-column
            prop="expireTime"
            align="center"
            label="到期日期"
          >
          </el-table-column>
          <el-table-column
            prop="years"
            align="center"
            label="续费年限"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="cardProductName"
            align="center"
            label="套餐类型"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="statusName"
            align="center"
            label="订单状态"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="handleStateName"
            align="center"
            label="处理状态"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="handleRemark"
            align="center"
            label="备注"
          >
          </el-table-column>
          <el-table-column
            prop="operate"
            align="center"
            label="操作"
            v-slot="{ row }"
          >
            <el-button @click="onEditStatue([ row.orderId ])" size="mini">修改</el-button>
            
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page.sync="params.pageNumber"
          :page-sizes="[100, 200, 300, 400]"
          :page-size.sync="params.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <UpdateOrderInfo 
        :visible.sync="visible" 
        :orderIds="orderIds" 
        @onSuccess="getData(true)" 
        @clearSelectio="clearSelection"
      />
    </div>
  </div>
</template>
<script>
import UpdateOrderInfo from './components/UpdateOrderInfo.vue';
export default {
  components:{
    UpdateOrderInfo
  },
  data(){
    return {
      tableData:[],
      total:0,
      loading:false,
      visible:false,
      orderIds:[],
      params:{
        time:[
          new Date(
            new Date().getTime() - 60*60*24*30*1000
          ).Format('yyyy-MM-dd'), 
          new Date().Format('yyyy-MM-dd')
        ],
        /** 订单id */
        orderId:'',
        /** SIM卡号 */
        simCard:'',
        /** 订单状态 */
        status:'',
        /** 处理状态 */
        handleState:'',
        operateType:'',
        pageNumber:1,
        pageSize:100
      },
      statusList:[
        { value:'', label:'全部' },
        { value:2, label:'成功' },
        { value:3, label:'退款' },
      ],
      handleStateList:[
        { value:'', label:'全部' },
        { value:1, label:'未处理' },
        { value:2, label:'已处理' },
      ],
    }
  },
  created(){
    this.getData();
  },
  methods:{
    useCardSupplier(type){
      return {
        1:'北京移动',
        2:'江门移动',
        3:'重庆卡',
        4:'江西卡',
        5:'深圳卡',
        6:'谷米卡',
        7:'北京移动(新)',
        8:'北京移动(新)',
        9:'北京移动(新)',
        10:'北京移动语音卡',
        11:'深圳移动',
        12:'联通',
        13:'北京移动4G卡',
        14:'惠州联通',
        15:'陕西移动',
        16:'云杉卡',
        17:'齐犇卡',
        18:'北京单4G卡',
      }[type];
    },
    //查询数据
    async getData(onoff = false){
      if(onoff){
        this.params.pageNumber = 1;
      }
      this.loading = true;
      let { time, ...params } = this.params;
      const { data, total,code, msg } = await this.$API.pageOrderInfo({
        startTime:time ? `${time[0]} 00:00:00` : '',
        endTime:time ? `${time[1]} 23:59:59` : '',
        ...params
      });
      this.loading = false;
      this.tableData = data || [];
      this.total = total || 0;
      this.$message({
        type:code === 0 ? 'success' : 'warning',
        message:code === 0 ? '搜索成功' : msg
      });
    },
    onEditStatue(ids){
      this.visible = true;
      this.orderIds = ids;
    },
    onExport(){
      let { time, pageNumber, pageSize, ...params } = this.params;
      this.$API.wechatOrder({
        startTime:time ? `${time[0]} 00:00:00` : '',
        endTime:time ? `${time[1]} 23:59:59` : '',
        ...params
      });  
    },
    onSelect(rows){
      this.orderIds = rows.map(item => item.orderId);
    },
    clearSelection(){
      this.$refs.refTable.clearSelection();
    }
  }
}
</script>
<style lang="scss" scoped>
.renewPrice{
  width: 100%;
  height:100%;
  padding: 10px 0;
  box-sizing: border-box;
  &__header {
    width: 100%;
    display: flex;
    padding: 10px 20px;
    background: #ffffff;
    height: 84px;
    align-items: center;
    font-size: 14px;
    box-sizing: border-box;
    .label{
      display: inline-block;
      margin-left: 10px;
    }
    .w__160{
      width: 160px;
    }
    .w__120{
      width: 120px;
    }
    .filter-type-input {
      background: #edf2f8;
      color: #828588;
      border: none;
      outline: 0;
      padding: 0 15px;
      height: 30px;
    }
    /deep/ .el-date-editor {
      width: 15%;
      .el-input__inner {
        padding-left: 30px;
        height: 30px;
        border-radius: 0;
        outline: none;
        border: 0;
        background: #f3f7fb;
      }
      .el-input__icon {
        line-height: 30px;
      }
    }
  }
  &__content {
    flex: 1;
    background: #fff;
    height: calc(100% - 84px);
    padding-top: 10px;
    padding:0 10px;
    .btn_cursor{
      color:#409EFF;
      display: inline-block;
      padding: 0 10px;
      cursor: pointer;
    }
    .filter-table-wrap {
      border: 1px solid #ebf0f6;
      height: 100%;
      /deep/ .el-pagination {
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-end;
        & > span {
          margin: 0;
        }
        .el-pagination__total {
          margin-right: auto;
        }
      }
    }
  }
}
</style>